// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3DGjF","head":"Table_head__2wi5q","col":"Table_col__2NEmY"};